import {useContext} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";
import {PersonFill} from "react-bootstrap-icons";

export default function CustomerBanner()
{
    const [state] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    if (!state.customer) {
        return null;
    }

    return (
        <div className="container">
            <div className="d-flex justify-content-center justify-content-md-end pt-2 pt-md-0">
                <span className="d-flex align-items-center gap-2 small px-2 py-1 rounded" style={{background: 'var(--bs-gray-100)', border: '1px solid var(--bs-gray-300)'}}>
                    <PersonFill style={{color: 'var(--bs-gray-600)'}} />
                    <span style={{color: 'var(--bs-gray-800)', fontWeight: 500}}>{state.customer.name}</span>
                    <span style={{color: 'var(--bs-gray-700)'}}>#{state.customer.id}</span>
                </span>
            </div>
        </div>
    );
}
